/** Base path for player-shell copies of public marketing/legal pages */
export const PLAYER_LEAGUE_INFO_BASE = '/player/league-info';

/** Map public site pathname → nested player route under {@link PLAYER_LEAGUE_INFO_BASE} */
export function publicPathToEmbeddedLeagueInfo(pathname) {
  const key = typeof pathname === 'string' && pathname.startsWith('/') ? pathname : `/${pathname || ''}`;
  switch (key) {
    case '/':
      return PLAYER_LEAGUE_INFO_BASE;
    case '/guide-to-hps':
      return `${PLAYER_LEAGUE_INFO_BASE}/guide-to-hps`;
    case '/how-league-works':
      return `${PLAYER_LEAGUE_INFO_BASE}/guide-to-hps`;
    case '/rules':
      return `${PLAYER_LEAGUE_INFO_BASE}/guide-to-hps`;
    case '/seasons':
      return `${PLAYER_LEAGUE_INFO_BASE}/guide-to-hps`;
    case '/partner-clubs':
      return `${PLAYER_LEAGUE_INFO_BASE}/partner-clubs`;
    case '/terms-and-conditions':
      return `${PLAYER_LEAGUE_INFO_BASE}/terms-and-conditions`;
    case '/privacy-policy':
      return `${PLAYER_LEAGUE_INFO_BASE}/privacy-policy`;
    default:
      return pathname;
  }
}

/** Registration CTA for logged-in players (stay inside player shell) */
export function embeddedRegisterTeamPath() {
  return '/player/register-team';
}
